import SvgChevron from '@img/icons/nav-chevron.svg';
import * as React from 'react';
import ArticleSummary from '../ArticleSummary/ArticleSummary';
import S from './DesktopDropdown.styles';
const DesktopDropdown = ({ articles, isActive, items, title }) => {
    const [activeLevel1, setActiveLevel1] = React.useState();
    const [activeLevel2, setActiveLevel2] = React.useState();
    // Reset state if navigation is toggled.
    React.useEffect(() => {
        if (isActive) {
            setActiveLevel1(undefined);
            setActiveLevel2(undefined);
        }
    }, [isActive]);
    const articlesToShow = activeLevel2?.articles ?? activeLevel1?.articles ?? articles ?? [];
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.Current, null, title),
            React.createElement(S.Column1, null,
                React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.Link, { href: item.url, tabIndex: isActive ? 0 : -1, target: item.target, "data-active": item.id === activeLevel1?.id, onMouseEnter: () => {
                            setActiveLevel2(undefined);
                            if (item.children?.length) {
                                setActiveLevel1(item);
                            }
                            else {
                                setActiveLevel1(undefined);
                            }
                        }, onKeyDown: (event) => {
                            switch (event.key) {
                                case 'ArrowRight':
                                    setActiveLevel1(item);
                                    break;
                                case 'ArrowLeft':
                                    setActiveLevel1(undefined);
                                    break;
                                default:
                                    break;
                            }
                        } },
                        React.createElement(S.Text, null, item.text),
                        !!item.children?.length && React.createElement(SvgChevron, null))))))),
            !!activeLevel1?.children?.length && (React.createElement(S.Column2, null,
                React.createElement(S.List, null, activeLevel1.children.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.Link, { href: item.url, tabIndex: isActive ? 0 : -1, target: item.target, "data-active": item.id === activeLevel2?.id, onMouseEnter: () => {
                            if (item.children?.length) {
                                setActiveLevel2(item);
                            }
                            else {
                                setActiveLevel2(undefined);
                            }
                        }, onKeyDown: (event) => {
                            switch (event.key) {
                                case 'ArrowRight':
                                    setActiveLevel2(item);
                                    break;
                                case 'ArrowLeft':
                                    setActiveLevel2(undefined);
                                    break;
                                default:
                                    break;
                            }
                        } },
                        React.createElement(S.Text, null, item.text),
                        !!item.children?.length && React.createElement(SvgChevron, null)))))))),
            !!activeLevel2?.children?.length && (React.createElement(S.Column3, null,
                React.createElement(S.List, null, activeLevel2.children.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.Link, { href: item.url, tabIndex: isActive ? 0 : -1, target: item.target },
                        React.createElement(S.Text, null, item.text)))))))),
            !!articlesToShow.length && activeLevel2 === undefined && (React.createElement(S.ArticleColumn, null,
                React.createElement(S.List, { as: "div" }, articlesToShow.map((item) => (React.createElement(ArticleSummary, { key: item.id, ...item, tabIndex: isActive ? 0 : -1 })))))))));
};
export default DesktopDropdown;
